import React from 'react';
import "./dropbox.css"
import droparrow from "../../assets/droparrow.svg"

const Dropbox = (props) => {
    return ( 
        <>
            <div className="dropbox">
                <span>{props.text}</span>
                <img src={droparrow} alt="" />
            </div>
        </>
     );
}
 
export default Dropbox;